export enum PeopleHappinessDataGroupBy {
  None = 'none',
  Department = 'department',
  Location = 'location',
}
